import { FolderOutlined } from '@ant-design/icons';
import { FC } from 'react';
import { Folder } from 'services';
import styles from './FilePickerComponents.module.scss';
import FilePickerFolderInfo from './FilePickerFolderInfo.component';

type FilePickerFolderCardProps = {
  folderData: Folder;
  onClick: () => void;
};

const FilePickerFolderCard: FC<FilePickerFolderCardProps> = ({ folderData, onClick }) => (
  <div className={styles.folderCardContainer}>
    <div className={styles.iconAndDataContainer} onClick={onClick}>
      <div className={styles.folderIconContainer}>
        <FolderOutlined style={{ fontSize: '24px', color: 'var(--gray-7)' }} />
      </div>

      <FilePickerFolderInfo
        folderName={folderData.name}
        foldersCount={folderData?.folders_count}
        filesCount={folderData?.files_count}
      />
    </div>
  </div>
);

export default FilePickerFolderCard;
